import { i18n } from '@/i18n'

export default () => [
  {
    path: '/login',
    component: () => import(/* webpackChunkName: "login" */ '@/views/login/index'),
    children: [
      {
        path: 'forget_pwd',
        name: 'forgetPwd',
        component: () => import(/* webpackChunkName: "forgetPwd" */ '@/views/login/forget'),
        meta: { title: i18n.t('account.forgotPassword') },
      },
      {
        path: 'register',
        name: 'register',
        component: () => import(/* webpackChunkName: "register" */ '@/views/login/register'),
        meta: { title: i18n.t('account.register') },
      },
      {
        path: 'register_success',
        name: 'registerSuccess',
        component: () => import(/* webpackChunkName: "registerSuccess" */ '@/views/login/registerSuccess'),
        meta: { title: i18n.t('account.registerCallback') },

      },
      {
        path: 'forget_success',
        name: 'forgetSuccess',
        component: () => import(/* webpackChunkName: "forgetSuccess" */ '@/views/login/reset'),
        meta: { title: i18n.t('account.resetPassword') },

      }
    ]

  }
]
